// ============================================================================
// ARABIC TRANSLATIONS - BIBLE TREASURES
// ============================================================================
// كنوز روحية مستخرجة من الكلمة

export const bibleTreasuresAr = [
  {
    type: "perle_sagesse",
    content: "الحكمة المقدسة ليست نظرية مجردة، بل حياة ملموسة تتجلى في خياراتنا اليومية",
    reference: "أمثال 3: 13-18",
    category: "الحكمة",
    strongNumbers: {
      "الحكمة": "H2451", // חָכְמָה (chokmah) = حكمة عملية
      "الفهم": "H8394" // תְּבוּנָה (tebunah) = تمييز
    },
    reflection: "كيف يمكنني تطبيق حكمة الله في قراراتي اليوم؟"
  },
  {
    type: "tresor_divine",
    content: "محبة الله ليست مشروطة بجدارتنا، بل هي عطية أبدية تنبع من جوهر الله نفسه",
    reference: "رومية 8: 38-39",
    category: "المحبة",
    strongNumbers: {
      "المحبة": "G26", // ἀγάπη (agape) = محبة غير مشروطة
      "يفصل": "G5563" // χωρίζω (chorizo) = يفصل
    },
    reflection: "لا شيء يمكن أن يفصلنا عن محبة الله المتجلية في المسيح"
  },
  {
    type: "lumiere_vie",
    content: "يسوع ليس فقط طريقنا، بل النور الذي ينير كياننا الداخلي",
    reference: "يوحنا 8: 12",
    category: "الهوية",
    strongNumbers: {
      "النور": "G5457", // φῶς (phos) = نور
      "الحياة": "G2222" // ζωή (zoe) = حياة وفيرة
    },
    reflection: "كيف أدع نور المسيح ينير مناطق ظلامي؟"
  },
  {
    type: "force_divine",
    content: "قوتنا لا تأتي من أنفسنا، بل من الذي يسكن فينا",
    reference: "أفسس 3: 16-17",
    category: "القوة",
    strongNumbers: {
      "يقوي": "G2901", // κραταιόω (krataioo) = يقوي
      "القوة": "G1411" // δύναμις (dynamis) = قوة إلهية
    },
    reflection: "هل أثق في قوة الله في لحظات ضعفي؟"
  },
  {
    type: "paix_profonde",
    content: "سلام الله لا يعتمد على الظروف الخارجية، بل على الحضور المستمر لله في قلوبنا",
    reference: "فيلبي 4: 6-7",
    category: "الهدوء",
    strongNumbers: {
      "السلام": "G1515", // εἰρήνη (eirene) = سلام كامل
      "يحفظ": "G5432" // φρουρέω (phroureo) = يحرس كحصن
    },
    reflection: "كيف أزرع سلام الله الذي يفوق كل عقل؟"
  },
  {
    type: "esperance_vivante",
    content: "رجاؤنا ليس أمنية غير مؤكدة، بل مرساة راسخة مبنية على وعود الله الأمينة",
    reference: "عبرانيين 6: 19",
    category: "الرجاء",
    strongNumbers: {
      "الرجاء": "G1680", // ἐλπίς (elpis) = رجاء واثق
      "مرساة": "G45" // ἄγκυρα (ankyra) = مرساة النفس
    },
    reflection: "في أي وعد من وعود الله أرسي رجائي اليوم؟"
  },
  {
    type: "transformation",
    content: "التحول الروحي عملية مستمرة، ونحن نصير كل يوم أكثر شبهاً بصورة المسيح",
    reference: "2 كورنثوس 3: 18",
    category: "النمو",
    strongNumbers: {
      "نتغير": "G3339", // μεταμορφόω (metamorphoo) = يتحول كلياً
      "المجد": "G1391" // δόξα (doxa) = مجد إلهي
    },
    reflection: "أي مجال من حياتي يحتاج إلى تحول اليوم؟"
  }
];

export default bibleTreasuresAr;
